// src/context/AlertContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import AlertMessage from '../components/common/AlertMessage';
import { setAlertHandler } from '../components/service/AlertService';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({ message: '', type: 'error' });

  const showAlert = (message, type = 'error') => {
    setAlert({ message, type });
  };

  const hideAlert = () => {
    setAlert({ message: '', type: 'error' });
  };

  useEffect(() => {
    setAlertHandler(showAlert);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {alert.message && (
        <AlertMessage
          message={alert.message}
          type={alert.type}
          onClose={hideAlert}
        />
      )}
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
